/* Gift City RD — motor de la landing (CTA Pagas al Recibir, countdown, galería, sticky, video) */
(function () {
  'use strict';

  /* Guard de idempotencia: gc-landing.js lo inyectan varias secciones (countdown +
     prueba-social), ambas presentes en product.json. Sin este guard boot() corre 2x
     → el listener tap-to-unmute de videos se registra doble (net = sin cambio) y se
     duplican los setInterval del countdown. */
  if (window.__gcBooted) return;
  window.__gcBooted = true;

  /* ---- Helper global de CTA: abre el buy-box en 1 toque ---- */
  window.srnOpenCOD = function srnOpenCOD() {
    // 1) Preferido: el buy-box nativo de Dawn (main-product)
    var buy =
      document.querySelector('.product-form__submit:not([disabled])') ||
      document.querySelector('form[action*="/cart/add"] [type="submit"]:not([disabled])');
    var picker =
      document.querySelector('product-info') ||
      document.querySelector('#ProductInfo') ||
      document.querySelector('product-form');
    if (picker) {
      var variantPicker = picker.querySelector('variant-selects, .product-form__input') || picker;
      variantPicker.scrollIntoView({ behavior: 'smooth', block: 'center' });
      if (buy) { setTimeout(function () { try { buy.focus({ preventScroll: true }); } catch (e) {} }, 450); }
      return;
    }
    // 2) Fallback WhatsApp parametrizado por producto (nunca hardcodear otro nombre)
    var cfg = window.GC_CONFIG || {};
    if (cfg.whatsapp) {
      var msg = encodeURIComponent(cfg.waMessage || ('Hola, quiero pedir el ' + (cfg.productTitle || 'anillo') + '.'));
      window.open('https://wa.me/' + cfg.whatsapp.replace(/[^0-9]/g, '') + '?text=' + msg, '_blank');
    }
  };

  document.addEventListener('click', function (e) {
    var t = e.target.closest('[data-gc-cta]');
    if (t) { e.preventDefault(); window.srnOpenCOD(); }
  });

  /* ---- Countdown evergreen: resetea a medianoche local ---- */
  function initCountdowns() {
    var timers = document.querySelectorAll('[data-gc-timer]');
    if (!timers.length) return;
    function tick() {
      var now = new Date();
      var end = new Date(now.getFullYear(), now.getMonth(), now.getDate() + 1, 0, 0, 0, 0);
      var diff = Math.max(0, end - now);
      var h = Math.floor(diff / 3.6e6);
      var m = Math.floor((diff % 3.6e6) / 6e4);
      var s = Math.floor((diff % 6e4) / 1e3);
      var pad = function (n) { return n < 10 ? '0' + n : '' + n; };
      var txt = pad(h) + ':' + pad(m) + ':' + pad(s);
      timers.forEach(function (el) { el.textContent = txt; });
    }
    tick();
    setInterval(tick, 1000);
  }

  /* ---- Galería hero: thumbnails, sin autoplay ---- */
  function initGallery() {
    document.querySelectorAll('[data-gc-gallery]').forEach(function (g) {
      var mains = g.querySelectorAll('.gc-gallery__main img');
      var thumbs = g.querySelectorAll('.gc-gallery__thumbs button');
      thumbs.forEach(function (btn, i) {
        btn.addEventListener('click', function () {
          mains.forEach(function (m, mi) { m.classList.toggle('is-active', mi === i); });
          thumbs.forEach(function (tb, ti) { tb.classList.toggle('is-active', ti === i); });
        });
      });
    });
  }

  /* ---- Sticky CTA: mostrar según body flag (CSS ya lo maneja) ---- */
  function initSticky() {
    var st = document.querySelector('.gc-sticky');
    if (st) {
      document.body.classList.add('gc-has-sticky');
      /* Dawn anima .product__info-wrapper con transform (scroll-trigger) → el
         ancestro transformado atrapa el position:fixed y el sticky queda
         "fijo" DENTRO del buy box (invisible al scrollear). Re-parent a body. */
      if (st.parentElement !== document.body) document.body.appendChild(st);
    }
    /* finding #5 · cuando el "Add to cart" nativo entra en viewport, esconde el
       sticky para que no lo tape (m1). Se re-muestra al scrollear fuera. */
    var buy = document.querySelector('.product-form__buttons') || document.querySelector('.product-form__submit');
    var sticky = document.querySelector('.gc-sticky');
    if (buy && sticky && 'IntersectionObserver' in window) {
      new IntersectionObserver(function (e) {
        sticky.classList.toggle('gc-sticky--hidden', e[0].isIntersecting);
      }, { threshold: 0 }).observe(buy);
    }
  }

  /* ---- Video reviews: autoplay al entrar en viewport (estilo reel) ---- */
  function initVideos() {
    var vids = document.querySelectorAll('video[data-gc-reel]');
    if (!vids.length || !('IntersectionObserver' in window)) return;
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        var v = en.target;
        if (en.isIntersecting) { v.play().catch(function () {}); }
        else { v.pause(); }
      });
    }, { threshold: 0.6 });
    vids.forEach(function (v) {
      io.observe(v);
      v.addEventListener('click', function () { v.muted = !v.muted; });
    });
  }

  function boot() {
    initCountdowns();
    initGallery();
    initSticky();
    initVideos();
  }
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
